'use client';
import type { ImageType } from '@eliadmin/core/src/api/api-types';
import { CategoryCard } from '@eliadmin/core/src/components/categories/category-card';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';

export type Category = {
  data?: Category[];
  childs: Category[];
  name: string;
  description: string;
  short_description: string;
  slug: string;
  icon?: string;
  image?: ImageType;
};

type CategoriesPageNewProps = {
  categories: Category[];
};

export const CategoriesPageNew = ({ categories }: CategoriesPageNewProps) => {
  return (
    <section className={cn('custom-section', 'pb-16 pt-6 sm:pt-10 lg:pb-24')}>
      <div
        className={cn(
          'custom-container',
          'grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
        )}
      >
        {categories.map(category => (
          <CategoryCard category={category as any} key={category.slug} showArrow />
        ))}
      </div>
    </section>
  );
};
